/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenMonitorIcon32Regular = forwardRef('TechScreenMonitorIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 3A5.5 5.5 0 0 0 2 8.5v10A5.5 5.5 0 0 0 7.5 24H12v3H9a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2h-3v-3h4.5a5.5 5.5 0 0 0 5.5-5.5v-10A5.5 5.5 0 0 0 24.5 3h-17Zm17 19a3.5 3.5 0 0 0 3.5-3.5v-10A3.5 3.5 0 0 0 24.5 5h-17A3.5 3.5 0 0 0 4 8.5v10A3.5 3.5 0 0 0 7.5 22h17ZM18 24v3h-4v-3h4Z" })));
});
